var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g, _ellipse, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _rect, _rect2, _path80, _path81, _path82, _path83, _path84, _path85, _rect3, _path86, _path87, _path88, _path89, _path90, _path91, _rect4, _rect5, _path92, _path93, _path94, _g2, _path95, _path96, _g3, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _g4, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _g5, _g6, _path134, _rect6, _rect7, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _rect8, _rect9, _path146, _path147, _path148, _path149, _rect10, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _rect11, _rect12, _path157, _path158, _path159, _g7, _path160, _path161, _g8, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _g9, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _rect13, _rect14, _path213, _path214, _path215, _path216, _rect15, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _rect16, _rect17, _path224, _path225, _path226, _g10, _path227, _path228, _g11, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _g12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "Horizontal_line_3",
    "data-name": "Horizontal line 3",
    width: 50,
    height: 50,
    patternTransform: "matrix(-.73 0 0 .73 760.4 81.85)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 0h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 6.27h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 12.53h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 18.8h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 25.06h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 31.33h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 37.59h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 43.73h50V50H0z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Horizontal_line_3-3",
    "data-name": "Horizontal line 3",
    width: 50,
    height: 50,
    patternTransform: "matrix(-.66 .32 .32 .66 692.6 -174.79)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 0h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 6.27h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 12.53h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 18.8h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 25.06h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 31.33h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 37.59h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 43.73h50V50H0z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Horizontal_line_5",
    "data-name": "Horizontal line 5",
    width: 50,
    height: 50,
    patternTransform: "matrix(.71 0 0 .71 718.11 1274.23)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0 0h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 6.27h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0 12.53h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 18.8h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0 25.06h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 31.33h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0 37.59h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 43.73h50V50H0z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Unnamed_Pattern_23",
    "data-name": "Unnamed Pattern 23",
    width: 50.86,
    height: 47.05,
    patternTransform: "matrix(.27 0 0 .28 711.77 1176.22)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0 0h50.86v47.05H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.82 46.67h50.9v47.52h-50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-.03 46.67h50.9v47.52H-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-50.89 46.67H.01v47.52h-50.9zM50.82-.38h50.9v47.52h-50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-.03-.38h50.9v47.52H-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M12.9 4.7h-1.8L11.08.05h1.81l.01 4.65zM20.38 6.83l-1.47 1.04-2.68-3.82 1.47-1.03 2.68 3.81zM13.65 14.45l-.35-1.77 4.57-.9.35 1.77-4.57.9zM22.64 13.24l-1.38-1.16 3-3.56 1.37 1.16-2.99 3.56zM26.98 19.7l-1.79-.16.4-4.64 1.8.16-.41 4.64zM16.93 21.17l.87-1.57 4.07 2.26-.88 1.58-4.06-2.27zM4.16 6.85L2.68 7.89 0 4.08l1.48-1.03 2.68 3.8zM6.41 13.26l-1.38-1.15 3-3.57 1.38 1.17-3 3.55zM10.75 19.73l-1.79-.16.41-4.65 1.79.17-.41 4.64zM.69 21.2l.88-1.57 4.07 2.25-.87 1.58L.69 21.2zM29.73 4.68h-1.81L27.91.02h1.81l.01 4.66zM37.21 6.81l-1.48 1.03-2.68-3.81L34.53 3l2.68 3.81zM30.48 14.43l-.35-1.77 4.57-.91.35 1.77-4.57.91zM39.46 13.22l-1.37-1.16 2.99-3.56 1.39 1.16-3.01 3.56zM43.81 19.68l-1.8-.16.4-4.64 1.8.16-.4 4.64zM33.75 21.15l.87-1.58 4.08 2.26-.88 1.58-4.07-2.26zM45.5 4.65l-1.81.01V0h1.8l.01 4.65zM46.26 14.4l-.35-1.77 4.56-.9.36 1.77-4.57.9zM12.94 28.29h-1.81l-.01-4.65 1.8-.01.02 4.66zM20.42 30.42l-1.48 1.04-2.67-3.81 1.47-1.04 2.68 3.81zM13.69 38.03l-.36-1.77 4.58-.9.35 1.77-4.57.9zM22.67 36.83l-1.38-1.16 3.01-3.56 1.37 1.16-3 3.56zM27.02 43.29l-1.8-.16.41-4.63 1.8.15-.41 4.64zM16.96 44.77l.87-1.58 4.07 2.26-.87 1.57-4.07-2.25zM4.19 30.44l-1.47 1.04-2.69-3.81 1.49-1.03 2.67 3.8zM6.44 36.85l-1.37-1.16 3-3.56 1.37 1.16-3 3.56zM10.79 43.31l-1.8-.15.41-4.64 1.8.16-.41 4.63zM.73 44.79l.88-1.58 4.06 2.26-.87 1.58-4.07-2.26zM29.76 28.26l-1.8.01-.01-4.66h1.8l.01 4.65zM37.25 30.39l-1.48 1.05-2.68-3.81 1.48-1.05 2.68 3.81zM30.52 38.01l-.35-1.76 4.57-.91.34 1.77-4.56.9zM39.49 36.81l-1.38-1.16 3.01-3.56 1.38 1.15-3.01 3.57zM43.84 43.26l-1.79-.16.41-4.63 1.79.16-.41 4.63zM33.78 44.74l.88-1.58 4.07 2.26-.87 1.58-4.08-2.26zM45.53 28.24l-1.8.01-.01-4.66h1.81v4.65zM46.29 37.99l-.35-1.77 4.57-.9.35 1.77-4.57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-50.89-.38H.01v47.52h-50.9zM50.82-47.42h50.9V.1h-50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-.03-47.42h50.9V.1H-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-50.89-47.42H.01V.1h-50.9z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Horizontal_line_5-5",
    "data-name": "Horizontal line 5",
    width: 50,
    height: 50,
    patternTransform: "rotate(26.32 -2260.074 2317.287) scale(.71)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0 0h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 6.27h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0 12.53h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 18.8h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0 25.06h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 31.33h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0 37.59h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 43.73h50V50H0z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Unnamed_Pattern_23-3",
    "data-name": "Unnamed Pattern 23",
    width: 50.86,
    height: 47.05,
    patternTransform: "matrix(.2 -.1 .11 .21 906.63 1145.21)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0 0h50.86v47.05H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.82 46.67h50.9v47.52h-50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-.03 46.67h50.9v47.52H-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-50.89 46.67H.01v47.52h-50.9zM50.82-.38h50.9v47.52h-50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-.03-.38h50.9v47.52H-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M12.9 4.7h-1.8L11.08.05h1.81l.01 4.65zM20.38 6.83l-1.47 1.04-2.68-3.82 1.47-1.03 2.68 3.81zM13.65 14.45l-.35-1.77 4.57-.9.35 1.77-4.57.9zM22.64 13.24l-1.38-1.16 3-3.56 1.37 1.16-2.99 3.56zM26.98 19.7l-1.79-.16.4-4.64 1.8.16-.41 4.64zM16.93 21.17l.87-1.57 4.07 2.26-.88 1.58-4.06-2.27zM4.16 6.85L2.68 7.89 0 4.08l1.48-1.03 2.68 3.8zM6.41 13.26l-1.38-1.15 3-3.57 1.38 1.17-3 3.55zM10.75 19.73l-1.79-.16.41-4.65 1.79.17-.41 4.64zM.69 21.2l.88-1.57 4.07 2.25-.87 1.58L.69 21.2zM29.73 4.68h-1.81L27.91.02h1.81l.01 4.66zM37.21 6.81l-1.48 1.03-2.68-3.81L34.53 3l2.68 3.81zM30.48 14.43l-.35-1.77 4.57-.91.35 1.77-4.57.91zM39.46 13.22l-1.37-1.16 2.99-3.56 1.39 1.16-3.01 3.56zM43.81 19.68l-1.8-.16.4-4.64 1.8.16-.4 4.64zM33.75 21.15l.87-1.58 4.08 2.26-.88 1.58-4.07-2.26zM45.5 4.65l-1.81.01V0h1.8l.01 4.65zM46.26 14.4l-.35-1.77 4.56-.9.36 1.77-4.57.9zM12.94 28.29h-1.81l-.01-4.65 1.8-.01.02 4.66zM20.42 30.42l-1.48 1.04-2.67-3.81 1.47-1.04 2.68 3.81zM13.69 38.03l-.36-1.77 4.58-.9.35 1.77-4.57.9zM22.67 36.83l-1.38-1.16 3.01-3.56 1.37 1.16-3 3.56zM27.02 43.29l-1.8-.16.41-4.63 1.8.15-.41 4.64zM16.96 44.77l.87-1.58 4.07 2.26-.87 1.57-4.07-2.25zM4.19 30.44l-1.47 1.04-2.69-3.81 1.49-1.03 2.67 3.8zM6.44 36.85l-1.37-1.16 3-3.56 1.37 1.16-3 3.56zM10.79 43.31l-1.8-.15.41-4.64 1.8.16-.41 4.63zM.73 44.79l.88-1.58 4.06 2.26-.87 1.58-4.07-2.26zM29.76 28.26l-1.8.01-.01-4.66h1.8l.01 4.65zM37.25 30.39l-1.48 1.05-2.68-3.81 1.48-1.05 2.68 3.81zM30.52 38.01l-.35-1.76 4.57-.91.34 1.77-4.56.9zM39.49 36.81l-1.38-1.16 3.01-3.56 1.38 1.15-3.01 3.57zM43.84 43.26l-1.79-.16.41-4.63 1.79.16-.41 4.63zM33.78 44.74l.88-1.58 4.07 2.26-.87 1.58-4.08-2.26zM45.53 28.24l-1.8.01-.01-4.66h1.81v4.65zM46.29 37.99l-.35-1.77 4.57-.9.35 1.77-4.57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-50.89-.38H.01v47.52h-50.9zM50.82-47.42h50.9V.1h-50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-.03-47.42h50.9V.1H-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-50.89-47.42H.01V.1h-50.9z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Horizontal_line_3-5",
    "data-name": "Horizontal line 3",
    width: 50,
    height: 50,
    patternTransform: "matrix(.79 0 0 .79 -934.49 15.14)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 0h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 6.27h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 12.53h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 18.8h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 25.06h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 31.33h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 37.59h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 43.73h50V50H0z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Horizontal_line_3-7",
    "data-name": "Horizontal line 3",
    width: 50,
    height: 50,
    patternTransform: "rotate(26.32 32.235 -2019.878) scale(.79)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 0h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 6.27h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 12.53h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 18.8h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 25.06h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 31.33h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 37.59h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 43.73h50V50H0z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Horizontal_line_3-9",
    "data-name": "Horizontal line 3",
    width: 50,
    height: 50,
    patternTransform: "matrix(-.38 0 0 .38 -643.94 393.46)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 0h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 6.27h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 12.53h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 18.8h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 25.06h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 31.33h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0 37.59h50v6.27H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0 43.73h50V50H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0 0h2000v800H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2451 374.55h800V746h-800z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_sans_nom_12",
    x1: 1001.61,
    y1: 759.88,
    x2: 999.05,
    y2: -9.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f7fdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#e0f8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#bcf0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#89e5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#48d7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2ed1ff"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,\n            .cls-17,\n            .cls-18,\n            .cls-55,\n            .cls-76,\n            .cls-77,\n            .cls-78 {\n                fill: none\n            }\n\n            .cls-2,\n            .cls-56 {\n                fill: #054752\n            }\n\n            .cls-19,\n            .cls-3,\n            .cls-40 {\n                fill: #fff\n            }\n\n            .cls-4 {\n                fill: #004753\n            }\n\n            .cls-5 {\n                fill: #eae8f5\n            }\n\n            .cls-9 {\n                fill: #669aa2\n            }\n\n            .cls-11 {\n                fill: #91b7bc\n            }\n\n            .cls-12 {\n                fill: #bdd4d7\n            }\n\n            .cls-13 {\n                fill: #cddadc\n            }\n\n            .cls-14 {\n                fill: #538c94\n            }\n\n            .cls-15 {\n                fill: #2e5862\n            }\n\n            .cls-16 {\n                fill: #d3e2e4\n            }\n\n            .cls-17,\n            .cls-76,\n            .cls-77,\n            .cls-78 {\n                stroke: #054752\n            }\n\n            .cls-17,\n            .cls-55,\n            .cls-76,\n            .cls-77,\n            .cls-78 {\n                stroke-miterlimit: 10\n            }\n\n            .cls-17 {\n                stroke-width: 4px\n            }\n\n            .cls-18 {\n                stroke: #fff;\n                stroke-linecap: round;\n                stroke-linejoin: round\n            }\n\n            .cls-19 {\n                opacity: .4\n            }\n\n            .cls-20,\n            .cls-22 {\n                fill: #947347\n            }\n\n            .cls-22,\n            .cls-28,\n            .cls-29,\n            .cls-31,\n            .cls-42,\n            .cls-44,\n            .cls-45,\n            .cls-52,\n            .cls-61,\n            .cls-62,\n            .cls-63,\n            .cls-73 {\n                mix-blend-mode: multiply\n            }\n\n            .cls-26 {\n                fill: #e9ca91\n            }\n\n            .cls-27,\n            .cls-28,\n            .cls-31 {\n                fill: #cd904d\n            }\n\n            .cls-30 {\n                fill: #014753\n            }\n\n            .cls-31,\n            .cls-44,\n            .cls-61 {\n                opacity: .67\n            }\n\n            .cls-33 {\n                fill: #a9b7c0\n            }\n\n            .cls-34 {\n                fill: url(#Horizontal_line_5)\n            }\n\n            .cls-35 {\n                fill: #01353a\n            }\n\n            .cls-55 {\n                stroke: #000\n            }\n\n            .cls-38,\n            .cls-39 {\n                fill: #2ed1ff\n            }\n\n            .cls-39,\n            .cls-40,\n            .cls-56 {\n                opacity: .45\n            }\n\n            .cls-41 {\n                fill: #004553\n            }\n\n            .cls-42 {\n                opacity: .49\n            }\n\n            .cls-43,\n            .cls-44,\n            .cls-45 {\n                fill: #ce914d\n            }\n\n            .cls-48 {\n                fill: #033\n            }\n\n            .cls-49,\n            .cls-52 {\n                fill: #eacb92\n            }\n\n            .cls-52 {\n                opacity: .59\n            }\n\n            .cls-55 {\n                stroke-width: .59px\n            }\n\n            .cls-57,\n            .cls-61,\n            .cls-62 {\n                fill: #facca3\n            }\n\n            .cls-63 {\n                opacity: .47;\n                fill: #95abbd\n            }\n\n            .cls-64 {\n                fill: #f5b240\n            }\n\n            .cls-67 {\n                fill: #f1890e\n            }\n\n            .cls-69,\n            .cls-73 {\n                fill: #f9cfc4\n            }\n\n            .cls-72 {\n                fill: url(#Horizontal_line_3-9)\n            }\n\n            .cls-73 {\n                opacity: .69\n            }\n\n            .cls-76 {\n                stroke-width: 10px\n            }\n\n            .cls-77 {\n                stroke-width: 20px\n            }\n\n            .cls-78 {\n                stroke-width: 7px\n            }\n\n            .cls-79 {\n                fill: #32707a\n            }\n        "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradient_sans_nom_12)",
    d: "M0 0h2000v551H0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M475.8 402.56s66.09-3.07 120.65-22.28c0 0 53 16.91 83 22.28s89.14-3.07 107.59 6.15c0 0 38.42 23.83 59.94 26.13s52.26 3.84 72.24-6.91 23.82-3.85 33 0 20.75 13.83 50-6.92 41.49-27.67 55.33-23.06 40.73 26.9 116.81 46.88 122.19-16.14 122.19-16.14 9.22-10 33.81-10 101.44-3.07 101.44-3.07L1049.09 670 559.56 500.93z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2136.51 57.51s-81.46 122.19-151.39 129.88c0 0-32.28 7.68-36.12 19.21s-12.3 26.9-26.9 27.67-43 13.06-71.47 0-60.71-12.3-84.53 6.14S1635.45 328 1584 350.31s-73.77 6.91-73.77 6.91-347.36 215.95-504.9 290.49l158.31 112.2 847.64-56.1 171.38-49.18z",
    fill: "#a7c6ca"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M-8.35 159s61.48-7 104.51 13.79S265.23 290.37 314.41 305s91.46 13.83 118.35 29.2 63.79 55.33 116.81 81.46 378.1 212.87 518 216.71L1049.09 670l-501.82-10-381.94-245.91z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-176.27-50.46s40-18.44 65.32 0 144.48 296.64 443.42 478c0 0 199.43 125.65 307 142.56s186 76.85 282.8 67.62 172.91 16.91 212.87 16.91 414.22-10.76 414.22-10.76l265.9-8.45-952.91 124.49H-175.88z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M-195.1 680s302 43.8 910.67 34.58l-67.63 25.36-405.76 10-442.65-6.14z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M973.78 703.81s-77.62-13.06-107.59-10-189.05 24.59-189.05 24.59-33 3.85-95.29 2.31c0 0-35.35 0-61.48 4.61S353.61 741.47 322.1 740.7s-509.51-6.92-509.51-6.92v26.13l464.17 30 577.14-23.85 135.25-34.58z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M624.89 719.18s-13.07 3.08-8.46 7.69 16.91 6.91 11.53 11.53-22.29 9.22-60.71 11.52-259.75 6.92-259.75 6.92L120 761.45l-417.29-1.54v16.91l532.56-9.22 180.6-5.38 156-6.15s55.33-4.61 61.48-10.76.77-13.06-2.31-14.6-11.52-3.07-11.52-5.38 5.37-6.15 5.37-6.15z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2163.41 510.15S1321.14 651.56 1015.28 690c0 0-171.37 26.13-201.35 43.8S953 738.4 953 738.4s-193.66 21.51-395.77 31.5-733.91 0-733.91 0V783l698.56 27.66 1630.74-5.38z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2169.55 797.57l-1108.16-7.69H519.6L296 783.74h-472.65l.77 64.55 501.05 8.45s263.6 11.53 480.31 33.82 571 41.5 646.3 125.26-102.21 179.06-102.21 179.06h802.31z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1510.51 722.19c0-5.17-5.42-9.37-12.11-9.37a15 15 0 00-5 .84 16.2 16.2 0 00-26.71 3.77 10.47 10.47 0 00-1.6-.13 9.51 9.51 0 00-9.78 9.18h53.86a7.72 7.72 0 001.34-4.29z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M401.42 723.75c0-5.14-5.39-9.32-12-9.32a14.81 14.81 0 00-5 .84 16.12 16.12 0 00-26.58 3.73 10.31 10.31 0 00-1.58-.12 9.46 9.46 0 00-9.73 9.13h53.56a7.67 7.67 0 001.33-4.26z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M962.57 748.33c0-5.15-5.39-9.32-12-9.32a14.87 14.87 0 00-5 .83 16.12 16.12 0 00-26.57 3.74 10.22 10.22 0 00-1.58-.12 9.47 9.47 0 00-9.73 9.13h53.56a7.64 7.64 0 001.32-4.26zM690.38 730.69c0-2.7-2.83-4.89-6.31-4.89a7.85 7.85 0 00-2.61.44 8.44 8.44 0 00-13.92 2 5.69 5.69 0 00-.83-.06 5 5 0 00-5.1 4.78h28.07a4.06 4.06 0 00.7-2.27zM853.66 709.94c0-2.69-2.82-4.88-6.3-4.88a7.81 7.81 0 00-2.61.44 8.45 8.45 0 00-13.93 2 5.55 5.55 0 00-.82-.07 5 5 0 00-5.1 4.79H853a4.05 4.05 0 00.66-2.28z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M277.96 689.41v34.94"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M298.51 663.59h-1c-.94-7.07-7.58-12.54-15.63-12.54a15.83 15.83 0 00-14.57 8.84 9.25 9.25 0 10-8.41 16.14 12.34 12.34 0 0016 17.2 16.52 16.52 0 009.24 2.7c6.85 0 12.59-3.86 14.06-9h.36a11.68 11.68 0 100-23.35z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1411.96 624.76v21.93"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1424.86 608.56h-.64c-.59-4.43-4.76-7.87-9.81-7.87a9.93 9.93 0 00-9.14 5.55 5.8 5.8 0 10-5.27 10.16 7.64 7.64 0 00-1 3.77 7.74 7.74 0 0011 7 10.37 10.37 0 005.79 1.7c4.3 0 7.91-2.42 8.83-5.68h.23a7.33 7.33 0 100-14.66z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1462.68 615.54v21.93"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1475.58 599.34h-.64c-.59-4.44-4.76-7.87-9.81-7.87a9.93 9.93 0 00-9.14 5.55 5.71 5.71 0 00-3.55-1.22 5.81 5.81 0 00-1.73 11.35 7.64 7.64 0 00-1 3.77 7.74 7.74 0 0011 7 10.37 10.37 0 005.79 1.7c4.31 0 7.91-2.43 8.83-5.68h.23a7.33 7.33 0 100-14.65z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1508.79 606.32v21.93"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1521.69 590.12h-.64c-.59-4.44-4.76-7.87-9.81-7.87a9.93 9.93 0 00-9.14 5.54 5.81 5.81 0 10-5.28 10.14 7.62 7.62 0 00-1 3.77 7.74 7.74 0 0011 7 10.37 10.37 0 005.79 1.7c4.3 0 7.91-2.43 8.83-5.68h.23a7.33 7.33 0 100-14.65z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1439.81 428.99h59M1428.31 441.49h59"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M928.1 451.61l26.25-23.33 35.73-14.59h83.13l18.96 14.59v15.31l-90.42 10.21h-45.94l-27.71-2.19z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M978.64 431.4c-.46.6-1 1.11-1.51 1.66-.82.87-3.34 2.8-3.32 5.12.05 3.81 2.66 4.51 4.4 4.62a3.75 3.75 0 001.45.07 6.62 6.62 0 002.77-1.57c1.38-2.13-.65-6 0-8.5.34-1.3.94-4.16-.81-4.76a1.23 1.23 0 00-1.53.59 26.12 26.12 0 01-1.45 2.77z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M979.3 432.71l4.49.08a13.62 13.62 0 012 8.41 51.3 51.3 0 01-5.32 1.44z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M983.14 433.49c-.13.05-.14 3.73-3.23 4.49l-.64-5z",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.64,
    fill: "#947347"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M978 428.09c.24 1-.18 1.42-.21 2.05-.15 3.11-.54 4.25 1.78 4.76 1.16.25 4.31-1.3 4.58-1.72 1-1.49 2.37-3.6 2.45-5.21a4.82 4.82 0 00-4.65-5.24 4.22 4.22 0 00-3.67 2.4c-.59 1.47-.66 1.58-.28 2.96z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M980.09 427.88a1.25 1.25 0 00-.63-.38 4.39 4.39 0 00-1 0c-.17 0-.17-.26 0-.26a4.6 4.6 0 011 0 1.49 1.49 0 01.73.44.13.13 0 01-.19.19z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 979.19,
    cy: 428.41,
    r: 0.3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M978 428.07a4.33 4.33 0 01-.66 1.38c-.26.35.19.7.52.72h-.09c1.16-.68.23-2.1.23-2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M978 430.49a7.45 7.45 0 011.12.8c-.17.67-1.17.66-1.17.66s-.9-.26-.3-.76c.21-.19-.29-.59.35-.7z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#573a22"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M977.88 452.55s6-5 5.63-5-3.64-6.62-3.64-6.62",
    fill: "url(#Horizontal_line_3)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M986.12 441.88s.43 2.9-2.09 7.95-11.66 11.7-12.27 11.89c-4.32 1.27-4.43-2.2-3.53-4 .76-1.5 2.77-4.83 8.17-11.46 2.49-3.05 6.78-7.26 9.72-4.38z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Horizontal_line_3-3)",
    d: "M979.88 442.41l-4.16 4.27 7.52 6.99"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M992.09 450.47l-3.67 14.62-10.94.1-1.11-14.91 15.72.19z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M988.83 465.09l-11.16-.16s-3 4.47.64 12.13c.39.84 2.24 8.52 2.24 8.52s9.1 2.64 13.22-.45c.41-.31 1.55-4.53 1.93-5.9 1.52-5.48-3.03-7.96-6.87-14.14z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M979.4 453.12s-5.62.49-5.62-2.82c0-1.75.14-.56 4.78-7.16"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M975 452.89c-1.65-1.92-3.77-.16-3.77-.16-4 3.33-10.63 10.8-12.46 14a9.44 9.44 0 00-.74 1.43 1.21 1.21 0 00.73 1.51c.55.19 2.13-1.09 2.13-1.09 18.79-12.47 15.3-14.35 14.11-15.69zM956.27 473.92a7.46 7.46 0 01-1.19 1.34 9.89 9.89 0 01-.67 1.37 10.58 10.58 0 00.05 1.18.66.66 0 01-.37.59l-.69-2.19.62-1.65.64-1.95a1.2 1.2 0 011.2.27 1 1 0 01.41 1.04z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M958.26 474.61c.22-.31.51-1.06.67-1.33.6-1 1.06-3.56 1.36-4.1a1.36 1.36 0 00-.21-2c-1-.8-1.55.43-1.55.43a7.11 7.11 0 01-.59 1 48.62 48.62 0 00-3.24 3.8s-.11.85.42 1.21a1.09 1.09 0 001.28.07c.13-.14.3-.35.57-.17a1.12 1.12 0 01.37 1.14c-.62 1.11-.58 1.18-.33 1.46a18.31 18.31 0 001.25-1.51z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M956.54 473.4a9.5 9.5 0 01-.9 1.56 10 10 0 01-.39 1.47 10.26 10.26 0 00.28 1.15.63.63 0 01-.24.65l-1.11-2 .28-1.75.24-2a1.06 1.06 0 011.18-.08 1.62 1.62 0 01.66 1zM977.15 445.17c1.1-1.2 3.84-7.82 3.84-7.82l6.15-.28s3.89 3.83 4.44 6.89a22.54 22.54 0 01.08 6.35h-13.9s-.66-5.09-.61-5.14z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M988.76 438.87a7.33 7.33 0 01-5.07 2.35c-3.16.08-3.87-1.17-3.87-1.17l-.65 1.32-5.39 8.11s-1.13 2.6 2.81 3.66l.89 12.06 10.94-.11s5-14.2 4-19.16-3.68-7.06-3.68-7.06"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M990.38 442.26s3.51 2.76 1.59 8.07c-1.11 3.09-5.37 15.61-5.85 16-3.32 3-4.94 0-4.91-2 0-1.68.1-9.11 1.92-13.74 1.44-3.68 3.35-9.59 7.25-8.33z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M986.78 463.44c1 2.3-1.44 3.48-1.44 3.48-4.71 2.25-14.27 5.11-17.93 5.44a9.53 9.53 0 01-1.61.07 1.21 1.21 0 01-1.06-1.3c.06-.57 1.88-1.47 1.88-1.47 19.18-11.79 19.38-7.83 20.16-6.22zM959.81 471.64a7.66 7.66 0 00-1.72.52 12 12 0 00-1.52 0 9.79 9.79 0 01-1.05-.53.63.63 0 00-.69.09l1.69 1.53 1.76.13 2 .25a1.19 1.19 0 00.26-1.21 1 1 0 00-.73-.78z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M960 469.54c.37-.06 1.17 0 1.49 0 1.19-.11 3.67.53 4.29.48s1.41 0 1.69 1c.32 1.21-1 1.23-1 1.23a7.79 7.79 0 00-1.14.12 49.56 49.56 0 01-4.82 1.35s-.81-.25-.92-.89a1.1 1.1 0 01.47-1.19c.19-.06.44-.12.4-.45a1.12 1.12 0 00-.88-.81c-1.27.1-1.32 0-1.47-.32.07-.06 1.33-.44 1.89-.52z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M960.39 471.61a9.91 9.91 0 00-1.79.17 11.18 11.18 0 00-1.5-.27 9.74 9.74 0 01-.93-.73.65.65 0 00-.69-.06l1.36 1.85 1.7.48 2 .64a1.06 1.06 0 00.57-1 1.73 1.73 0 00-.72-1.08z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M991.17 454.12s4.25-11.5-1.38-12.16c-5-.59-7.61 9.92-7.61 9.92z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M995.21 443.27a5.62 5.62 0 01-3.57-.43 28.3 28.3 0 01-3.63-1.66 3.48 3.48 0 01-1.2-.91 3.8 3.8 0 01-.59-1.69 3.46 3.46 0 01.15-2.36 2.19 2.19 0 011.68-1c2.29-.24 5 1.61 6.65 3a6.62 6.62 0 012.13 2.38 2.28 2.28 0 01-1.62 2.67z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M996.56 434.05a3 3 0 011.66 1.13 3.8 3.8 0 010 2.79 2.12 2.12 0 01-1.84.85c-1.89 0-3.45-1.39-5.18-2.16a15.86 15.86 0 01-2.27-1 2.41 2.41 0 01-1.25-2c.2-4.36 7.22-.26 8.88.39z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M985.49 428.9a3.09 3.09 0 002.78.55 6.81 6.81 0 003.25 4.55 3.45 3.45 0 001.52.6 3.6 3.6 0 001.37-.24 4.17 4.17 0 002.65-2 2.5 2.5 0 00-2-3.48c-.68-.07-1.37.15-2 0a3.56 3.56 0 01-1.81-1.07 28.54 28.54 0 01-2.07-3.36c-2.16-3.06-4.37-2-5.41-2-2.51.25.23 5.22 1.72 6.45z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M982.53 425.46c-.17 0-4.61.79-5.83-1.08s.34-4.44 3.49-4.05c3.84.47 7.53 3.36 7.91 5.14.62 2.89-5.57-.01-5.57-.01z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M978.9 423.85s1.52 5.75 3.46 5.5 2.2-3.51 2.2-3.51z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M980.39 424.73s3.74 2.75 2.62 6.29c-2 6.43-.12 10.19 3.31 11.45s8.19 1.22 8.28.79-5.48-17.26-5.48-17.26z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M982.49 429.36s.78-.92 1.2-.44-.15 2.14-.64 1.92a3.7 3.7 0 01-.82-.49z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M983 429.41a.27.27 0 01.39.07.57.57 0 010 .14.41.41 0 01-.07.31.19.19 0 01-.26.06"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M956.12 460.43a2 2 0 00.91-.23 2 2 0 00.83-2.63l-7.54-14.35a2 2 0 10-3.45 1.82l7.53 14.34a2 2 0 001.72 1.05z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1043.07 454.77c-1.76-1-3 .92-3 .92-2.43 3.67-6 11.24-6.68 14.2a9 9 0 00-.26 1.3.92.92 0 00.94.95c.48 0 1.44-1.42 1.44-1.42 12.01-14.72 8.79-15.24 7.56-15.95z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1041 437.19s4.49.05 4.38 5.92c-.06 2.78-.85 13.95-1.12 14.41-1.92 3.18-3.81 1-4.21-.66-.34-1.39-1-7.52-1.43-11.7-.25-2.53-.87-8.23 2.38-7.97z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1052.59 459.93l-12.49.27s.61 6.52 1 9c.13.76 1.09 6.6 1.09 6.6s7.25 2.24 10.54-.38a11.2 11.2 0 001-3.09c1.27-4.67 1.92-7.16-1.14-12.4z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1035.26 437.72l3.46-4.1s9 1.43 11 6.2c3.25 7.8 3.2 20.21 3.2 20.21l-12.75.17z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1031.84 433.3l4.41-3.32s3.71 4.47 4.09 5.58c.07.2-5 2.48-5 2.48z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1029.08 427.22c0 .34.32.79.28 1a3.83 3.83 0 00.08 1.6c.7 2.64.35 2.46.78 3.37.32.69 1.09 1.09 2.62 1 1.12 0 3.34-2.5 3.73-2.82 1.81-1.49 1.65-5.86 1.27-7.57-.79-3.6-3.67-3.32-5.64-2.42-2.92 1.36-3.2 4.62-3.12 5.84z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1030.92 426.84a1.43 1.43 0 00-1.55.22"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 1030.27,
    cy: 428.53,
    rx: 0.28,
    ry: 0.3
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1029.4 427.46c-.6 1.59-.73 2.16-.43 2.34a.77.77 0 00.73 0c.21-.17-.27-2.37-.3-2.34z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1034.56 433.46c-.09.05.76 2.25 0 3.64l-2.1-2.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1031.91 432.45c-1.06.27-1.54-1.46-1.43-1.72",
    style: {
      mixBlendMode: "multiply"
    },
    stroke: "#cd904d",
    strokeWidth: 1.02,
    opacity: 0.67,
    strokeMiterlimit: 10,
    fill: "none"
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1029.75 428.67a1.45 1.45 0 00.9.86c.4.12 1.23 0 1.35-.68"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1030.67 430.5c-.33-.31-.85-.67-1.26-.48v1.8l1.92-.17a2.87 2.87 0 00-.66-1.15z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1039 433.66s9.45 1.56 11.22 6.19a47.58 47.58 0 012.65 13.37c.54 7.8-.13 6.77-.13 6.77l-12.74.16-4.7-21.69s4.2-2.11 3.7-4.8z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1044.7 437.06s3.53 2.76-.12 7.35c-1.74 2.18-9.15 10.58-9.65 10.77-3.45 1.36-3.63-1.53-2.94-3.08.58-1.31 3.8-6.56 6-10.16 1.3-2.18 4.27-7.08 6.71-4.88z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1035.65 452.26c-.78-1.88-3-1.11-3-1.11-4.17 1.44-11.57 5.3-13.94 7.21a8.94 8.94 0 00-1 .88.92.92 0 00.17 1.33c.38.29 2-.26 2-.26 18.58-4.4 16.31-6.73 15.77-8.05z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1014.67 463.11a7.69 7.69 0 01-1.33.69c-.12 0-.5.61-.92.84-.06 0-.15.5-.3.9a.55.55 0 01-.46.35l.07-1.82 1-1.08 1.06-1.3a1 1 0 01.89.52.77.77 0 01-.01.9z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1016.07 464.15c.27-.18.71-.67.91-.83.78-.62 1.85-2.39 2.25-2.72s.86-.78.39-1.52-1.36-.09-1.36-.09a7.48 7.48 0 01-.75.58c-.67.41-2.69 1.27-3.68 2 0 0-.33.61 0 1a1 1 0 001 .4c.15-.08.34-.19.51 0a.83.83 0 010 .95c-.81.67-.8.73-.67 1 .03.01 1.01-.48 1.4-.77z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1015 462.78a8.62 8.62 0 01-1.16.93c-.12.06-.37.7-.73 1a5.57 5.57 0 00-.1.94.53.53 0 01-.38.42l-.32-1.8.71-1.23.77-1.48a1 1 0 011 .25 1.3 1.3 0 01.21.97z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1044.73 437.06s3.52 2.76-.13 7.35c-1.73 2.18-9.15 10.58-9.64 10.77-3.46 1.36-3.63-1.53-2.94-3.08.57-1.31 3.8-6.56 6-10.16 1.29-2.18 4.26-7.08 6.71-4.88z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1035.27 452.48c-.78-1.88-3-1.11-3-1.11-4.16 1.44-11.57 5.3-13.94 7.22a7.21 7.21 0 00-1 .87.93.93 0 00.16 1.33c.38.29 2-.26 2-.26 18.59-4.4 16.33-6.73 15.78-8.05z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1033 476.12a6.78 6.78 0 01-.63 1.36 10.34 10.34 0 01-.22 1.24 7.47 7.47 0 00.31.89.57.57 0 01-.16.56l-1-1.49.11-1.44.05-1.68a1 1 0 011-.13.76.76 0 01.54.69z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1034.75 476.1c.1-.3.15-1 .22-1.21.23-1 0-3 .13-3.52s.21-1.15-.62-1.45-1.13.76-1.13.76c-.12.46-.14.65-.24.92a39.65 39.65 0 00-1.71 3.82s.11.68.62.81a1 1 0 001-.3c.08-.15.16-.35.42-.29a.86.86 0 01.56.78c-.24 1-.19 1.06.08 1.21.05-.07.53-1.06.67-1.53z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1033.1 475.65a8.84 8.84 0 01-.36 1.44 10.2 10.2 0 010 1.24 8.29 8.29 0 00.49.81.54.54 0 010 .57l-1.35-1.24-.18-1.42-.29-1.63a.94.94 0 01.92-.39 1.28 1.28 0 01.77.62z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1034.64 427.83s.38 1.19-.12 1.55a1.18 1.18 0 01-.73.2s.59 1.74 1.42 1.11-.57-2.86-.57-2.86z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1027.06 424.25a2.83 2.83 0 01-1.44-2.63 2.93 2.93 0 011.75-2.44 2.12 2.12 0 011.11-.17c.86.12 1.47.89 2.27 1.22a1.61 1.61 0 011.6-.75 2.33 2.33 0 011.54 1c.11.15.24.33.43.35a.79.79 0 00.41-.15 2.05 2.05 0 012.15.48c1.17 1 2.68 1.6 1.87 4.72-.39 1.48-.54 2.52-1 4-1.36.49-3.13.31-2.86-1.58-.28.21-1.33-.27-1.59-.51s-.19-3.44-2.65-3.67c-1.29-.12-2.23.88-3.59.13z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1033.62 428.53s.27-1.23.83-.9.55 1.77 0 1.71a2 2 0 01-.88-.28z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1034.05 428.43c0-.19.19-.36.33-.22a.33.33 0 010 .14.44.44 0 010 .32.2.2 0 01-.27.07z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#8e405f",
    opacity: 0.18,
    d: "M1126.8 531.74l-295.99-1.28 13.86-6.45 261.48-1 20.65 8.73z"
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.1 449.69s8.46 15.32 5.64 24.72c-3.89 13-12.28 30.76-12.28 30.76",
    strokeWidth: 0.29,
    stroke: "#000",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M844.47 475.62c0-20.82 85.4-26.14 85.4-26.14l186.06-.08 4.67-.15 2.4 46.25-11.44 10.42h-260.4c-4.09 0-7.19-3.31-6.48-6.92l.8-4s-.75-17.93-1-18.2c-1.9-1.9-.01-.92-.01-1.18z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1045.82,
    y: 459.81,
    width: 13.61,
    height: 3.32,
    rx: 1.21,
    transform: "rotate(180 1052.62 461.465)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 982.16,
    y: 459.81,
    width: 13.61,
    height: 3.32,
    rx: 1.21,
    transform: "rotate(180 988.96 461.465)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M862.55 467.75s-1.14 11.95-5.25 11.95c-8.74 0-14.19.25-14.19.25s-.61-8.66 7.1-11.15a31.5 31.5 0 0112.34-1.05z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M918.5 505.51h144.99l3.51-13.72H913.46l5.04 13.72z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    transform: "rotate(-180 985.685 509.895)",
    d: "M918.5 507.85h134.36v4.09H918.5z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1100.58 507.85h15.9v4.09h-13.55a2.34 2.34 0 01-2.34-2.34v-1.75h-.01z",
    transform: "rotate(-180 1108.53 509.895)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    transform: "rotate(-180 858.97 509.895)",
    d: "M845.28 507.85h27.38v4.09h-27.38z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1122.92 458.31h-18.6s-.27 13 10.5 15c9 1.6 8.37.2 8.37.2z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1102.94,
    y: 451.71,
    width: 21.38,
    height: 5.48,
    rx: 1.99,
    transform: "rotate(-180 1113.63 454.445)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1050.07 446.43c.81-.07 5.54-.6 11.51-1.44l.94 5.21h-58.21l.14-.87c15.64-.69 31.83-1.63 45.62-2.9z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1091 437c.67-2.71-14-20.12-27.49-20.54-.5 0-2 0-4.15-.06l-.07-.37h-2.93l.06.35c-11.41-.08-33.57-.18-46.87-.21v-.14h-6.39v.13h-.6c-36.73 0-66.23 30.22-66.23 30.22s2.22 2.48 3.42 3.89h-17.04s2.53-1.68 13.57-12c8.54-8 33.33-26.36 63.77-26.36 21.55 0 85.71-.61 86.5-.61 9 0 10.87 3.61 9.43 9.39-1.69 6.75 23.42 26.68 24.62 29.55h-55.15l-1-5.63c11.49-1.78 25.78-4.55 26.55-7.61z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1059.3 416l.07.37h-2.94l-.06-.35z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1064.44 444.57l1 5.63.6 3.36h-2.93l-.6-3.36-.94-5.21-5.15-28.65h2.94zM981.06 450.22c5.41-.17 11.12-.37 17-.61l5.16-33.49v-.13h6.39v.14l-5.11 33.21-.14.87-.47 3.08h-6.39l.47-3.07z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M852.61 484.2c2.72 0 7.7 9.45 7.7 13.95s-5 8.18-7.7 8.18h-2.19a6.31 6.31 0 01-6.31-6.32v-8c0-1.12.91-7.8 2-7.8zM1124.21 476.67s-16-3.17-23.62 5.69-10.59 23.41-10.59 23.41l21.83.1c6 .06 12.41.07 12.41-12.11z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M844.61 483.42H860a1.37 1.37 0 001.37-1.37 1.37 1.37 0 00-1.37-1.36h-15.39M943.05 443v19.44a6.64 6.64 0 01-6.63-6.63v-6.21a6.64 6.64 0 016.63-6.6z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 933.09,
    y: 468.95,
    width: 64.21,
    height: 11.45,
    rx: 3.45,
    transform: "rotate(-180 965.195 474.675)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 1009.26,
    y: 468.95,
    width: 44.62,
    height: 11.45,
    rx: 3.45,
    transform: "rotate(-180 1031.575 474.675)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1121.82 461.87a4.31 4.31 0 100 8.61"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M919 506.14a24.11 24.11 0 00-48.21 0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M875 506.44a19.92 19.92 0 0019.89 19.89A19.89 19.89 0 10875 506.44z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M878.23 517.27a19.88 19.88 0 1031.84-23.68l-10.1 7.5-11.66 8.68z"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M887.51 506.43a7.39 7.39 0 107.39-7.38 7.39 7.39 0 00-7.39 7.38zM1101.07 506.14a24.11 24.11 0 00-48.21 0"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1057.09 506.44a19.9 19.9 0 0019.91 19.89 19.89 19.89 0 10-19.88-19.89z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1060.3 517.27a19.88 19.88 0 1031.84-23.68l-10.1 7.5-11.66 8.68z"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1069.59 506.43a7.39 7.39 0 107.38-7.38 7.38 7.38 0 00-7.38 7.38z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M854 462.61l-27.12-24.11-36.93-15.07h-85.9l-19.59 15.07v15.82l93.44 10.55h47.47l28.63-2.26z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M774.94 484.37a1.29 1.29 0 01-1.28 1.3h-6.33a1.27 1.27 0 01-1.33-1.27 1.28 1.28 0 011.28-1.29h6.33a1.28 1.28 0 011.29 1.28z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M781.24 454.61s-1.39 3.35.17 6.06c1.85 3.2 9.62 16.76 10.22 17.18 4.14 2.89 5.18-1.43 4.86-3.65s-.59-7.85-3-12.89c-2.15-4.5-6.36-12.47-12.25-6.7z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M781.57 461.06l5.38 16.46 13.99.11 1.12-16.25-20.49-.32z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M785 483.52c-.09.21-2.74 3.91-3.06 7.23s3.11 7.68 3.11 7.68l13.46.14 1.59-9.32.75-11.92-13.86.19a48.55 48.55 0 01-1.99 6zM795.62 439.33l-7.8.11a32.33 32.33 0 00-1 10.11c0 .27 6.73 2.19 6.73 2.19z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M800.68 456c-1.54-2.73-6.78-8.86-6.78-8.86L787 446a17.23 17.23 0 00-6.25 9.43c0 .23.44 6.42.44 6.42h21s-1.47-5.85-1.51-5.85zM797.85 433a4.66 4.66 0 00-.35 1.31c0 .72.43 1.5.41 1.91-.15 3.47.64 3.12.34 4.39-.22.94-1.44 1-3.46 1.39-1.49.3-5.19-1.35-5.79-1.63-2.81-1.27-3.87-6.72-3.87-8.94 0-4.68 3.86-5.23 6.71-4.72a7.67 7.67 0 013.72 1.73 7.59 7.59 0 012.29 4.56z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M795.05 433.05a2.07 2.07 0 012.52-.15"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 796.27,
    cy: 434.31,
    r: 0.38
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M797.36 433.49a32.25 32.25 0 001.45 3.06c0 .11-.91.26-1 .26s-.45-3.32-.45-3.32z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M791.21 442.23c.15.07-.88 4.31 3 5.48l.94-5.75z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M797.88 437.49s-1 .25-1 .44c0 .39 1.07.43 1.07.43z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M800.83 429.17a1.63 1.63 0 00-1.76-1.49c-.35.05-.67.23-1 .28a.76.76 0 01-.88-.41c-.09-.29.1-.58.17-.88a1.51 1.51 0 00-1.14-1.63c-.7-.21-1.46.36-2.19.32-2.17-.11-4.12-.64-6.66 1.05l2.73 2.2c-.17-.07-.27.2-.24.38a4.26 4.26 0 001.57 2.61 3.36 3.36 0 001.47.77c3.62.63.92-3.14 4.17-2 .94.54 1.51 1 2.34.76a2 2 0 001.42-1.96z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M795.93 429.05s-4.23-5.47-10.49-1.74c-3.81 2.27-2.13 8 2.1 12.81a3.89 3.89 0 002.38-1.21c.63-1.06.58-4.14.58-4.14l2.21.46.67-2.84a7.38 7.38 0 012.55-3.34z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M790.25 434s-.15 1.58.61 1.87a1.64 1.64 0 001 0s-.27 2.33-1.54 1.81-.07-3.68-.07-3.68z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M791.8 434.56s-.72-1.43-1.35-.85a1.25 1.25 0 00.87 2.1c.75 0 .83-.18.83-.18z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M791.2 434.58c0-.26-.35-.4-.49-.18v.06a.62.62 0 000 .19.52.52 0 00.17.37.28.28 0 00.38 0z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M786.36 446.08l10.18 3.74 4.3 6.14 1.22 5.08-1.78 24.58-14.89-3.44 1.57-4.89-6.09-16.59s-1.43-6.17 1.48-9.85 4-4.77 4-4.77",
    fill: "url(#Unnamed_Pattern_23)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.84,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    d: "M786.12 445.98l10.83 4.06"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M785.35 445.34s14.9 5.11 16.17 12.17c.71 3.9.33 4.47.33 4.47a24.13 24.13 0 00-18.43-14.47"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M738.23 463.16s-6.35-5.3-6-5.3 3.88-7.06 3.88-7.06"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M729.44 451.77s-.46 3.1 2.23 8.49 12.44 12.49 13.1 12.69c4.61 1.36 4.73-2.34 3.76-4.26-.8-1.6-2.95-5.16-8.71-12.23-2.67-3.27-7.24-7.76-10.38-4.69z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Horizontal_line_5-5)",
    d: "M736.1 452.34l4.44 4.56-8.03 7.46"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M723.07 460.94l3.92 15.61 11.67.11 1.18-15.92-16.77.2z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M726.55 476.55l11.91-.17s3.18 4.77-.68 12.95c-.42.89-2.39 9.09-2.39 9.09s-9.72 2.82-14.12-.48c-.44-.33-1.66-4.84-2.06-6.3-1.62-5.85 3.24-8.5 7.34-15.09zM736.61 463.77s6 .53 6-3c0-1.87-.15-.6-5.1-7.65M744.88 473c1.77 2 4 .13 4 .13 4.26-3.59 11.25-11.62 13.18-15a11.12 11.12 0 00.78-1.53 1.29 1.29 0 00-.8-1.6c-.58-.2-2.26 1.18-2.26 1.18-19.89 13.4-16.15 15.37-14.9 16.82zM764.73 450.36a8.58 8.58 0 011.25-1.44c.14-.1.32-1 .71-1.46a10.48 10.48 0 00-.06-1.26.68.68 0 01.39-.63l.75 2.32-.65 1.77-.66 2.09a1.27 1.27 0 01-1.29-.27 1.07 1.07 0 01-.44-1.12z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M762.59 449.65c-.22.33-.52 1.13-.69 1.42-.63 1.12-1.1 3.81-1.42 4.39a1.44 1.44 0 00.24 2.09c1 .84 1.65-.47 1.65-.47A8.1 8.1 0 01763 456c.6-.79 2.59-2.74 3.43-4.09a1.46 1.46 0 00-.46-1.28 1.16 1.16 0 00-1.36-.07c-.15.16-.32.37-.62.19a1.18 1.18 0 01-.39-1.22c.65-1.19.6-1.26.33-1.56-.06.1-1 1.15-1.34 1.68z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M764.44 450.92a10.67 10.67 0 01.95-1.67 14.29 14.29 0 01.4-1.58 9.91 9.91 0 00-.3-1.22.7.7 0 01.25-.7l1.2 2.13-.29 1.87-.23 2.18a1.14 1.14 0 01-1.26.1 1.8 1.8 0 01-.72-1.11zM739 455.28c-1.17-1.28-4.09-8.34-4.09-8.34l-6.57-.31s-4.15 4.1-4.74 7.36a24.07 24.07 0 00-.09 6.78h14.84s.72-5.43.65-5.49z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M726.62 448.56a7.86 7.86 0 005.42 2.51c3.37.08 4.12-1.25 4.12-1.25l.7 1.4 5.75 8.67s1.21 2.77-3 3.9l-1 12.87-11.61-.11s-5.36-15.16-4.3-20.46 3.93-7.53 3.93-7.53"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M724.89 452.17s-3.74 2.95-1.7 8.62c1.19 3.3 5.74 16.67 6.25 17.13 3.55 3.24 5.27 0 5.24-2.18 0-1.8-.11-9.73-2-14.68-1.59-3.92-3.63-10.27-7.79-8.89z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M728.74 474.79c-1.12 2.45 1.53 3.71 1.53 3.71 5 2.4 15.23 5.46 19.14 5.8a10 10 0 001.72.08 1.28 1.28 0 001.13-1.38c-.06-.62-2-1.57-2-1.57-20.48-12.59-20.74-8.37-21.52-6.64z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M757.53 483.54a8.9 8.9 0 011.83.55 12.15 12.15 0 011.62 0c.09 0 .61-.33 1.13-.57a.68.68 0 01.73.09l-1.84 1.68-1.87.14-2.18.26a1.26 1.26 0 01-.28-1.29 1.07 1.07 0 01.86-.86z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#eacb92"
  }), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M757.3 481.3c-.4-.06-1.25 0-1.59 0-1.27-.12-3.92.56-4.58.51s-1.5 0-1.8 1.08c-.35 1.29 1.11 1.31 1.11 1.31a7.55 7.55 0 011.22.13c1 .22 3.56 1.23 5.14 1.44 0 0 .87-.27 1-1a1.17 1.17 0 00-.5-1.27c-.2-.07-.47-.13-.43-.48a1.19 1.19 0 01.94-.86c1.36.1 1.41 0 1.57-.34-.11-.01-1.46-.43-2.08-.52z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M756.9 483.51a9.65 9.65 0 011.91.18 11.92 11.92 0 011.61-.29 10.49 10.49 0 001-.78.69.69 0 01.74-.06l-1.45 2-1.82.51-2.08.69a1.14 1.14 0 01-.61-1.11 1.83 1.83 0 01.7-1.14z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M724.05 464.84s-4.54-12.28 1.47-13c5.31-.62 8.12 10.6 8.12 10.6z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M733.86 428.15a5.16 5.16 0 014.22 4.34 135.68 135.68 0 011.21 13.91l-16-.12s-2-20.16 10.57-18.13z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M729.4 441.96l-1.41 6.01h7.06v-7.42l-5.65 1.41z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M729.84 442.21c.16.05 0 3.33 5.33 4l-.22-5.48z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M737.17 436.59c0 3.6-1.93 6.46-5.16 6.46s-5.1-3-5.1-6.56S728.78 430 732 430s5.17 3 5.17 6.59z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M728.34 435.9c.3-.39 2.1-.51 2.49.06M733.63 436a2.51 2.51 0 012.75.12"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 729.38,
    cy: 436.88,
    r: 0.38
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 734.78,
    cy: 436.88,
    r: 0.38
  }))), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M730.71 439.2h2.85a1.54 1.54 0 01-1.46 1.23 1.45 1.45 0 01-1.39-1.23z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 726.23,
    y: 436.12,
    width: 1.46,
    height: 2.46,
    rx: 0.33
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 736.16,
    y: 436.12,
    width: 1.46,
    height: 2.46,
    rx: 0.33
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M729.35 430.45s-.84 4.19-.48 4.31 4.56.12 4.56.12.84-4.43.72-3.95a31.94 31.94 0 00.36 3.95l1.67.36s1.08-6.95-2-6.83-4.59.36-4.83 2.04z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M732.53 435.91l.05 1.91-1.13.18s1 1 1.6.5 0-2.45-.52-2.59zM727.12 436.8c0 .05-.12 0-.19 0a.22.22 0 00-.19.12.65.65 0 00-.08.22 1.47 1.47 0 000 .36.43.43 0 00.18.3.57.57 0 00.29 0M736.92 436.79a.33.33 0 01.31.21 1.1 1.1 0 010 .4.77.77 0 01-.07.34.27.27 0 01-.28.17.11.11 0 01-.07-.06"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M727.42 447.53l-2 2.35s13.59 8.17 12.84 24.88l.55.27s4.2-19.26-11.36-27.5"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M825.92 464.54a2 2 0 01-.92-.22 2 2 0 01-.82-2.64l7.53-14.35a2 2 0 013.46 1.82l-7.53 14.34a1.94 1.94 0 01-1.72 1.05z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M782.5 453.24c0 .49-2.23 4.58 1.76 13.55 4.14 9.36 16.24 13.54 16.24 13.54l.34-4.06z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#054752"
  }), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M801.94 468.34c.56 2.27 3.69 2.08 3.69 2.08 6.12-2.44 13-5.67 16.93-7.27.73-.3.87-.66 1.3-.88l-.56-3c-21.65 1.52-21.84 7.13-21.36 9.07zM828.26 457.64a9.05 9.05 0 011.86-.8c.17 0 .75-.8 1.34-1.08a11.49 11.49 0 00.52-1.23.72.72 0 01.66-.43l-.35 2.56-1.42 1.4-1.58 1.7a1.34 1.34 0 01-1.11-.85 1.14 1.14 0 01.08-1.27z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M826.54 456c-.37.22-1 .85-1.31 1.05-1.11.78-1.2 1.29-3.11 3.11-2.06 2-.19 3.45.82 2.85.34-.2.73-.55 1.08-.73.94-.49 3.73-1.44 5.15-2.35a1.58 1.58 0 00.14-1.44 1.23 1.23 0 00-1.27-.69c-.21.09-.48.22-.68-.09a.92.92 0 01.35-1.2c1-.73 1.07-1.25.86-1.49-.29.24-1.47.61-2.03.98z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M827.73 458.05a10.87 10.87 0 011.67-1.16c.16-.08.58-.94 1.1-1.33a10.33 10.33 0 00.26-1.32.75.75 0 01.57-.55l.17 2.59-1.12 1.65-1.21 2a1.21 1.21 0 01-1.25-.48 1.88 1.88 0 01-.19-1.4zM783.45 456.12s.46 3.62 3.18 5.2c3.21 1.86 15.94 10.15 19 8.61 4.53-2.32 2.36-2.59 1-4.37s-4.45-6.54-9.07-9.73c-4.2-2.83-11.87-7.7-14.11.29z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M798.37 456.19l-6.11 8.9s-13.28-6.65-10.12-11 8.43-7.3 16.23 2.1z",
    fill: "url(#Unnamed_Pattern_23-3)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M792.79 465.55l6.35-8.63c.38-.52-.49-1-.87-.51l-6.34 8.59c-.38.52.49 1 .86.51z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M775.88 459.71s-8.62 15.62-5.75 25.2c4 13.24 12.51 31.35 12.51 31.35"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M937.57 486.14c0-21.22-87-26.65-87-26.65l-189.66-.08-4.75-.15-2.47 47.14 11.62 10.6h265.45c4.16 0 7.32-3.37 6.59-7l-.8-4.1s.76-18.27 1-18.54c1.94-1.95.02-.95.02-1.22z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 718.47,
    y: 470.02,
    width: 13.87,
    height: 3.38,
    rx: 1.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 783.36,
    y: 470.02,
    width: 13.87,
    height: 3.38,
    rx: 1.2
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M919.14 478.12s1.16 12.18 5.35 12.18c8.92 0 14.47.25 14.47.25s.62-8.82-7.24-11.36a32 32 0 00-12.58-1.07z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M862.11 516.61H714.32l-3.57-13.99h156.5l-5.14 13.99z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M725.16 518.99h136.95v4.17H725.16zM663.28 519h13.24v4.17h-16.2V522a3 3 0 012.96-3zM908.84 518.99h27.9v4.17h-27.9z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M653.75 468.49h19s.27 13.29-10.7 15.25c-9.16 1.64-8.54.21-8.54.21z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 652.32,
    y: 461.77,
    width: 21.79,
    height: 5.58,
    rx: 1.99
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M728 456.39c-.84-.08-5.65-.61-11.74-1.48l-1 5.32h59.34l-.14-.89c-15.89-.7-32.4-1.66-46.46-2.95zM781.06 459.63l.09.62h17.19c-5.51-.18-11.34-.38-17.28-.62z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M686.28 446.73c-.69-2.76 14.26-20.51 28-20.94l4.24-.05.06-.38h3l-.06.36c11.63-.09 34.22-.18 47.77-.22v-.14h6.51v.13h.61c37.44 0 67.51 30.8 67.51 30.8s-2.27 2.53-3.48 4h17.38S855.24 458.55 844 448c-8.7-8.16-34-26.87-65-26.87-22 0-87.37-.62-88.17-.62-9.12 0-11.08 3.68-9.61 9.57 1.72 6.87-23.88 27.19-25.09 30.12h56.21l1-5.74c-11.71-1.74-26.27-4.57-27.06-7.73zM711.71 463.65h2.99l.61-3.42h-2.98l-.62 3.42z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M721.58 425.36h-3l-.06.38h3zM713.36 454.49l-1 5.74h3l1-5.32z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M718.53 425.74l-5.17 28.75 2.91.42 5.25-29.19zM775.13 463.38h6.51l-.49-3.13-6.5-.01.48 3.14zM775.78 425.36h-6.51v.14h6.51zM774.51 459.35l.14.89h6.5l-.09-.62z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M769.29 425.5l5.22 33.85 6.55.28-5.26-34.14z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M929.27 494.89c-2.77 0-7.84 9.63-7.84 14.21 0 4.59 5.07 8.34 7.84 8.34h2.23a6.44 6.44 0 006.44-6.44v-8.16c0-1.14-.92-7.95-2.07-7.95zM652.43 487.21s16.34-3.21 24.08 5.79 10.75 23.87 10.75 23.87L665 517c-6.08 0-12.65.06-12.65-12.35z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M937.43 494.09H921.7a1.39 1.39 0 01-1.39-1.39 1.4 1.4 0 011.39-1.4h15.73M837.09 452.86v19.82a6.78 6.78 0 006.76-6.76v-6.3a6.78 6.78 0 00-6.76-6.76z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 781.79,
    y: 479.34,
    width: 65.45,
    height: 11.67,
    rx: 4.15
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 724.11,
    y: 479.34,
    width: 45.48,
    height: 11.67,
    rx: 4.15
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M654.87 472.12a4.39 4.39 0 110 8.78"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M861.61 517.25a24.57 24.57 0 1149.13 0"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M906.44 517.56a20.29 20.29 0 01-20.27 20.27 20.28 20.28 0 1120.27-20.27z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M903.16 528.6a20.27 20.27 0 11-32.45-24.15L881 512.1l11.88 8.9z"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M893.7 517.55a7.53 7.53 0 11-7.53-7.53 7.53 7.53 0 017.53 7.53zM676 517.25a24.57 24.57 0 1149.14 0"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M720.85 517.56a20.26 20.26 0 11-20.27-20.28 20.14 20.14 0 0120.27 20.28z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M717.58 528.6a20.27 20.27 0 11-32.46-24.15l10.3 7.65 11.88 8.9z"
  }))), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M708.11 517.55a7.53 7.53 0 11-7.53-7.53 7.53 7.53 0 017.53 7.53z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M630.81 428.99h59M619.31 441.49h59M1087.81 420.99h59M1101.31 433.49h59"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1660.59 461.02l-26.25-23.33-35.74-14.58h-83.13l-18.95 14.58V453l90.42 10.21h45.94l27.71-2.19z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1629.62 467.69a1.86 1.86 0 01-.91-.23 1.94 1.94 0 01-.82-2.63l7.53-14.35a2 2 0 113.46 1.82l-7.54 14.34a1.94 1.94 0 01-1.72 1.05z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1607.25 440.21l-8 .11s-1.21 3.6-1 10.32c0 .28 6.86 2.23 6.86 2.23z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1612.41 457.19c-1.58-2.78-6.92-9.05-6.92-9.05l-7.09-1.14a17.54 17.54 0 00-6.37 9.63c0 .23.44 6.55.44 6.55h21.42s-1.43-5.91-1.48-5.99zM1609.93 441.6c-.23.91-1.47 1-3.53 1.35h-.05a3.41 3.41 0 01-.9 0 11.41 11.41 0 01-1.73-.39 29.61 29.61 0 01-3.23-1.19c-2.87-1.24-4-6.52-4-8.67 0-4.55 3.94-5.08 6.85-4.59a8 8 0 013.79 1.69 7.2 7.2 0 012.34 4.42 4.48 4.48 0 00-.35 1.28c0 .69.43 1.44.41 1.84v.36c-.04 2.98.69 2.72.4 3.9z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M1606.66 433.8a2.1 2.1 0 012.57-.16",
    fill: "#95abbd",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1607.91,
    cy: 435.08,
    r: 0.39,
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#014753"
  }), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1609 434.24a31.11 31.11 0 001.48 3.12c0 .12-.92.27-1 .27a3.21 3.21 0 01-.62-1.41 5.75 5.75 0 01.14-1.98z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1602.74 443.16c.16.08-.89 4.41 3.09 5.6l1-5.88z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1609.55 438.32s-1 .27-1 .45c0 .4 1.1.44 1.1.44z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1609.93 441.6c-.23.91-1.47 1-3.53 1.35h-1a8 8 0 01-1.07-.11 1.78 1.78 0 01-.66-.28c-1.41-.94-1.46-3.77-1.46-3.77l7.29-1.23v.14c-.01 2.98.72 2.72.43 3.9zM1610.56 442.73s.02-.01 0 0z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1602.16 432.32s6.71.31 7.65-.55 3.82-5.78-1.17-5.78a12.17 12.17 0 00-8.2 3.36z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1598.38 445.72l8.87 4.53 5.3 7 1.44 6h-21.57l-.48-7.19s1.86-5.43 4.76-7.63z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1598.17 445.29l9.11 5.03-10.06-3.36.95-1.67z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1607.57 429.71s-4.33-5.58-10.72-1.77c-3.89 2.32-2.17 8.12 2.15 13.07a3.91 3.91 0 002.42-1.24c.65-1.07.6-4.22.6-4.22l2.25.47s.58-2.47.69-2.9a7.52 7.52 0 012.61-3.41z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1601.76 434.77s-.14 1.62.63 1.92a1.67 1.67 0 001 0s-.27 2.38-1.57 1.85-.06-3.77-.06-3.77z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1603.35 435.33s-.74-1.46-1.38-.86a1.27 1.27 0 00.89 2.14c.77 0 .84-.18.84-.18z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1602.74 435.35a.29.29 0 00-.51-.18v.06a.65.65 0 000 .2.58.58 0 00.17.38.3.3 0 00.39 0z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M1598.94 457.45s-.24 3.08 1.75 4.86c2.34 2.1 12.23 11 12.82 11.22 4.12 1.24 3.82-2.53 3-4.25s-2.55-6.2-5.84-9.64c-2.96-3.08-8.48-8.43-11.73-2.19z",
    fill: "#8f4160",
    opacity: 0.3
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1614.26 473.33c1.17 1.23 2.06.59 2.06.59 4.25-3.62 9.41-8.49 12.09-10.83.5-.44.52-.77.8-1.06l-1.26-2.25c-16.95 7.11-14.87 12.33-13.69 13.55zM1631.48 457.12a7.63 7.63 0 011.27-1.16c.13-.07.39-.84.79-1.23a9.16 9.16 0 00.08-1.13.61.61 0 01.41-.52l.42 2.15-.76 1.51-.8 1.79a1.16 1.16 0 01-1.13-.37 1 1 0 01-.28-1.04z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1629.65 456.25c-.23.28-.58 1-.76 1.21-.69.92-.62 1.36-1.65 3.34-1.12 2.14.78 2.82 1.43 2.06.22-.25.44-.64.67-.88a46.45 46.45 0 003.49-3.29 1.32 1.32 0 00-.28-1.19 1.06 1.06 0 00-1.21-.21c-.14.13-.32.31-.57.11a.78.78 0 010-1c.58-.85.52-1.3.28-1.43-.2.23-1.05.85-1.4 1.28z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1631.17 457.59a8.92 8.92 0 011-1.39 11.57 11.57 0 01.52-1.37 8.48 8.48 0 00-.14-1.12.62.62 0 01.3-.6l.84 2-.44 1.63-.44 1.92a1 1 0 01-1.13 0 1.59 1.59 0 01-.51-1.07zM1599.42 457s-.24 3.08 1.74 4.86c2.35 2.1 12.24 11 12.83 11.22 4.12 1.24 3.82-2.53 3-4.25s-2.56-6.2-5.84-9.64c-2.96-3.11-8.48-8.46-11.73-2.19z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#19b4d8",
    d: "M1604.4 465.18l7.19-6.71-7.19-5.52-5.03 1.44-1.2 4.56 6.23 6.23z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1611.59 458.47l-7.19 6.71.48.48 7.19-6.71-.48-.48z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M1554.24 434.57s-1.08 5.14 1.89 7.66c5.81 4.91.49 10.19-4.22 9s-3.26-11.09-3.26-11.09z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1553.11 435.92s-.28 4.6 1.84 7.82c2.59 3.91-.17 7.88-2.41 7.65-.44-.05-4.48-5.27-4.48-5.27s4.01-10.22 5.05-10.2z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#f5b240"
  }), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1553.09 439.36l-4.73-.15a14.35 14.35 0 00-2.49 8.76c0 .23 5.53 1.8 5.53 1.8z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1555.41 462.11s-6.4-5.34-6.05-5.34 3.92-7.11 3.92-7.11",
    fill: "url(#Horizontal_line_3-5)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1546.55 450.64s-.45 3.12 2.25 8.55 12.53 12.58 13.2 12.81c4.64 1.37 4.76-2.35 3.79-4.28-.81-1.61-3-5.19-8.77-12.32-2.7-3.33-7.3-7.84-10.47-4.76z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Horizontal_line_3-7)",
    d: "M1553.26 451.21l4.47 4.6-8.08 7.51"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1540.14 459.88l3.95 15.71 11.75.11 1.19-16.03-16.89.21z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1543.64 475.59l12-.17s3.21 4.8-.68 13c-.42.89-2.41 9.15-2.41 9.15s-9.78 2.84-14.21-.48c-.44-.33-1.67-4.87-2.08-6.35-1.64-5.84 3.26-8.51 7.38-15.15z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1553.78 462.72s6 .54 6-3c0-1.89-.15-.61-5.14-7.7"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1558.47 462.47c1.77-2.05 4-.16 4-.16 4.32 3.58 11.43 11.61 13.39 15a9.17 9.17 0 01.8 1.53 1.3 1.3 0 01-.79 1.62c-.58.2-2.28-1.17-2.28-1.17-20.11-13.36-16.37-15.37-15.12-16.82zM1578.63 485.08a8.42 8.42 0 001.28 1.44 11.14 11.14 0 00.73 1.47c0 .07-.05.7-.05 1.27a.68.68 0 00.39.63l.74-2.35-.67-1.77-.68-2.09a1.28 1.28 0 00-1.3.28 1.1 1.1 0 00-.44 1.12z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1576.49 485.82c-.23-.34-.54-1.14-.71-1.43-.64-1.12-1.14-3.82-1.46-4.4a1.46 1.46 0 01.22-2.11c1-.86 1.66.46 1.66.46a8.23 8.23 0 00.64 1.06c.61.8 2.63 2.74 3.49 4.09a1.5 1.5 0 01-.46 1.3 1.18 1.18 0 01-1.37.08c-.15-.16-.32-.38-.62-.19a1.2 1.2 0 00-.39 1.23c.67 1.19.62 1.26.35 1.57-.05-.08-1.01-1.13-1.35-1.66z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1578.34 484.52a10.07 10.07 0 001 1.67 12.94 12.94 0 00.42 1.59 11.62 11.62 0 01-.3 1.24.69.69 0 00.26.7l1.19-2.16-.3-1.87-.25-2.2a1.15 1.15 0 00-1.27-.09 1.87 1.87 0 00-.75 1.12zM1556.2 454.18c-1.18-1.29-4.13-8.4-4.13-8.4l-6.61-.31s-4.18 4.12-4.78 7.41a24.58 24.58 0 00-.08 6.82h14.94s.71-5.46.66-5.52z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1543.72 447.41a7.89 7.89 0 005.45 2.53c3.39.08 4.15-1.26 4.15-1.26l.71 1.41 5.79 8.73s1.21 2.79-3 3.93l-1 12.95-11.75-.11s-5.39-15.26-4.33-20.59 4-7.59 4-7.59"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1542 451.05s-3.76 3-1.7 8.67c1.19 3.33 5.77 16.78 6.28 17.25 3.58 3.26 5.31 0 5.28-2.2 0-1.8-.11-9.79-2.06-14.77-1.58-3.95-3.63-10.35-7.8-8.95z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1545.85 473.82c-1.12 2.47 1.54 3.74 1.54 3.74 5.07 2.41 15.34 5.49 19.28 5.84a9.91 9.91 0 001.72.08 1.3 1.3 0 001.14-1.4c-.06-.61-2-1.58-2-1.58-20.64-12.67-20.89-8.42-21.68-6.68zM1574.84 482.63a8.45 8.45 0 011.84.55 12.46 12.46 0 011.64 0 11.3 11.3 0 001.13-.57.69.69 0 01.74.09l-1.83 1.65-1.89.14-2.18.27a1.28 1.28 0 01-.29-1.3 1.08 1.08 0 01.84-.83z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1574.61 480.37c-.41-.06-1.26 0-1.6 0-1.29-.12-4 .57-4.61.52s-1.52-.05-1.82 1.08c-.35 1.3 1.12 1.32 1.12 1.32a10.33 10.33 0 011.22.13 53 53 0 005.18 1.45s.87-.27 1-.95a1.18 1.18 0 00-.51-1.28c-.2-.07-.47-.14-.43-.49a1.2 1.2 0 01.95-.86c1.37.1 1.42 0 1.58-.35-.1-.05-1.46-.48-2.08-.57z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1574.2 482.6a9.87 9.87 0 011.93.18 10.48 10.48 0 011.61-.29 10.9 10.9 0 001-.79.69.69 0 01.75-.05l-1.46 2-1.83.51-2.1.69a1.14 1.14 0 01-.61-1.11 1.82 1.82 0 01.71-1.14z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1541.13 463.8s-4.57-12.36 1.48-13.07c5.34-.63 8.18 10.67 8.18 10.67z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M1549.83 440.69c-.23 1.09.47 4.76 2.17 5.34l1-6z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1554.89 434.71c-.08 1.19-.09 2.16-.08 3v.6c0 2.65.15 3-2.07 3.39-1.23.21-4.48-1.6-4.75-2.05-1-1.62-2.3-3.91-2.3-5.62a5.08 5.08 0 015.16-5.28 4.49 4.49 0 013.76 2.71 6.36 6.36 0 01.28 3.25z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1552.42 434a.83.83 0 01.27-.17 2.2 2.2 0 01.44-.12 3.91 3.91 0 011.44.11c.18 0 .25-.24.07-.28a4.26 4.26 0 00-1.59-.1 1.7 1.7 0 00-.83.35c-.13.13.07.33.2.21z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#edb6ab"
  }), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 1553.43,
    cy: 434.84,
    r: 0.31
  }))), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1554.68 434.41a16.76 16.76 0 00.83 1.46c.2.29 0 .31-.32.4l-.5.09c-.33.03-.01-1.95-.01-1.95z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1554.57 438.27a.8.8 0 01-.73-.54l.73-.06z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M1549.78 430.14c.09 0 .24.91 1 .91 2.49 0 4.87-.72 4.22-3.15-.38-1.4-2.1-1.63-4.9-.74-3.81 1.2-6 3.46-6.42 4.68-.68 1.99 6.1-1.7 6.1-1.7z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M1552 429.19a6.73 6.73 0 01-1 4c-.5.81-3.24 1.47-3.31 2.74 0 .62.93 1.61 1 2.41.43 5.76.93 12.6-6.87 13.12-4.91.32-7.64-1.37-6.92-6.7.25-1.81 2.6-3.74 6.48-4.32.86-.13 1.56-4.13 1.82-6.89a5.55 5.55 0 011.7-3.48s5.01-2.26 7.1-.88z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M1547.46 435.37c0 .1-.94 3.21 1.21 4 .23.08.15-2.11.15-2.11z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1549 435.67s-.85-1-1.36-.53.41 2.31 1 2.1.61-.51.61-.51z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1548.58 435.75a.36.36 0 00-.46.06.33.33 0 000 .15.43.43 0 00.06.33.24.24 0 00.3.07",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#f9cfc4"
  }), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1585 458.21s-8.34 15.12-5.56 24.39c3.84 12.81 12.11 30.34 12.11 30.34"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1741.46 483.79c0-20.53-84.24-25.79-84.24-25.79l-183.53-.07-4.6-.15-2.39 45.62 11.3 10.28h256.87c4 0 7.09-3.27 6.39-6.83l-.79-4s.74-17.69 1-17.95c1.85-1.81-.01-.85-.01-1.11z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1529.43,
    y: 468.2,
    width: 13.42,
    height: 3.27,
    rx: 1.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1592.22,
    y: 468.2,
    width: 13.42,
    height: 3.27,
    rx: 1.2
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1723.62 476s1.13 11.79 5.18 11.79c8.63 0 14 .24 14 .24s.6-8.54-7-11a31 31 0 00-12.18-1.03z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1668.43 513.28h-143.02l-3.46-13.54h151.45l-4.97 13.54z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1535.9 515.59h132.53v4.03H1535.9zM1476.12 515.59h12.71v4h-15.68v-1.07a3 3 0 012.97-2.93zM1713.65 515.59h27v4.03h-27z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1466.8 466.72h18.34s.27 12.86-10.35 14.76c-8.86 1.58-8.26.2-8.26.2z"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1465.41,
    y: 460.21,
    width: 21.09,
    height: 5.4,
    rx: 1.99
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1538.66 455c-.81-.07-5.47-.59-11.36-1.42l-.93 5.14h57.42l-.13-.86c-15.43-.68-31.4-1.6-45-2.86zM1590 458.14l.09.6h16.63c-5.33-.17-10.96-.37-16.72-.6z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1498.28 445.66c-.67-2.67 13.8-19.85 27.11-20.26.49 0 1.95 0 4.09-.06l.07-.36h2.89l-.06.34c11.25-.08 33.11-.17 46.23-.2v-.14h6.3v.13h.59c36.23 0 65.32 29.8 65.32 29.8s-2.19 2.44-3.36 3.84h16.82s-2.5-1.66-13.38-11.86c-8.42-7.9-32.88-26-62.9-26-21.26 0-84.55-.61-85.33-.61-8.83 0-10.72 3.56-9.3 9.26 1.67 6.66-23.11 26.32-24.28 29.15h54.39l1-5.56c-11.35-1.68-25.48-4.41-26.2-7.47zM1522.89 462.03h2.89l.59-3.31h-2.89l-.59 3.31z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1532.44 425h-2.89l-.07.36h2.9zM1524.48 453.16l-1 5.56h2.89l.93-5.14z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1529.48 425.34l-5 27.82 2.82.42 5.08-28.26zM1584.26 461.77h6.3l-.47-3.03-6.3-.01.47 3.04zM1584.89 425h-6.3v.14h6.3zM1583.66 457.87l.13.86h6.3l-.09-.6z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1578.61 425.12l5.05 32.75 6.34.27-5.09-33z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1733.42 492.26c-2.67 0-7.59 9.32-7.59 13.76 0 4.43 4.92 8.06 7.59 8.06h2.17a6.23 6.23 0 006.23-6.23V500c0-1.1-.9-7.69-2-7.69zM1465.52 484.83s15.81-3.12 23.3 5.61 10.4 23.09 10.4 23.09l-21.53.1c-5.88.06-12.24.07-12.24-11.94z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1741.32 491.49h-15.22a1.36 1.36 0 01-1.35-1.35 1.36 1.36 0 011.35-1.35h15.22M1644.22 451.58v19.19a6.57 6.57 0 006.54-6.55v-6.09a6.57 6.57 0 00-6.54-6.55z"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 1590.7,
    y: 477.22,
    width: 63.34,
    height: 11.29,
    rx: 4.15
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 1534.89,
    y: 477.22,
    width: 44.02,
    height: 11.29,
    rx: 4.15
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1467.88 470.23a4.25 4.25 0 110 8.49"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1668 513.9a23.77 23.77 0 1147.54 0"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1711.33 514.2a19.61 19.61 0 11-19.62-19.62 19.43 19.43 0 0119.62 19.62z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1708.16 524.88a19.61 19.61 0 11-31.41-23.36l10 7.4 11.5 8.56z"
  }))), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1699 514.19a7.29 7.29 0 11-7.29-7.29 7.29 7.29 0 017.29 7.29zM1488.35 513.9a23.78 23.78 0 1147.55 0"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1531.73 514.2a19.61 19.61 0 11-19.61-19.62 19.43 19.43 0 0119.61 19.62z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1528.56 524.88a19.61 19.61 0 11-31.41-23.36l10 7.4 11.5 8.56z"
  }))), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1519.4 514.19a7.29 7.29 0 11-7.28-7.29 7.28 7.28 0 017.28 7.29z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M108.64 829.67c0-144 116.75-260.78 260.78-260.78S630.2 685.64 630.2 829.67"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M624.65 829.67c0-144 116.76-260.78 260.78-260.78s260.79 116.75 260.79 260.78M1151.67 829.67c0-144 116.75-260.78 260.78-260.78s260.78 116.75 260.78 260.78"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M1668.74 829.67c0-144 118.8-260.78 260.78-260.78 144 0 260.78 116.75 260.78 260.78"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M-136.29 492.96H2183"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M65.83 541.15v-48.29M158.97 541.15v-48.29M252.11 541.15v-48.29M345.24 541.15v-48.29M438.38 541.15v-48.29M531.51 541.15v-48.29M624.65 541.15v-48.29M717.79 541.15v-48.29M810.92 541.15v-48.29M904.06 541.15v-48.29M997.2 541.15v-48.29M1090.33 541.15v-48.29M1183.47 541.15v-48.29M1276.61 541.15v-48.29M1369.74 541.15v-48.29M1462.88 541.15v-48.29M1556.02 541.15v-48.29M1649.15 541.15v-48.29M1742.29 541.15v-48.29M1835.43 541.15v-48.29M1928.56 541.15v-48.29"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-136.69 524.1H2183v42.01H-136.69z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.48 556.21v247.3l-29.33 20.61v45.98h110.97v-48.36l-33.29-22.19V556.21H82.48zM604.04 556.21v247.3l-29.33 20.61v45.98h110.97v-48.36l-33.29-22.19V556.21h-48.35zM1125.61 556.21v247.3l-29.33 20.61v45.98h110.97v-48.36l-33.29-22.19V556.21h-48.35zM1647.17 556.21v247.3l-29.33 20.61v45.98h110.97v-48.36l-33.29-22.19V556.21h-48.35z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M86.82 668.06c-2.44 0-4.84.11-7.22.32-6.66-50.08-53.71-88.88-110.77-88.88-46.6 0-86.52 25.88-103.22 62.65a65.27 65.27 0 00-40.11-13.71A65.55 65.55 0 00-240 694a65.58 65.58 0 0046 62.59 87 87 0 00-11.06 42.58 87.39 87.39 0 0087.4 87.39 87 87 0 0036.79-8.1c17.74 12 40.56 19.17 65.46 19.17 48.57 0 89.23-27.39 99.66-64.13h2.6a82.74 82.74 0 000-165.47zM373.13 797.22q-2.11 0-4.2.18c-3.87-29.13-31.24-51.7-64.44-51.7-27.11 0-50.33 15.06-60.05 36.44a38.14 38.14 0 10-34.69 66.58 50.85 50.85 0 0065.81 70.89 68.17 68.17 0 0038.08 11.16c28.26 0 51.91-15.94 58-37.31h1.51a48.13 48.13 0 100-96.26z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1947.08 681.16v91.83"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2001.1 613.31c-.9 0-1.79.05-2.67.12-2.47-18.57-19.92-33-41.08-33-17.28 0-32.09 9.6-38.28 23.23a24.31 24.31 0 10-22.07 42.48 32.43 32.43 0 0042 45.2 43.44 43.44 0 0024.27 7.11c18 0 33.09-10.16 37-23.79h1a30.69 30.69 0 100-61.37z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1980 281.93s51.27-5.76 87.17 11.54 141 98.06 182 110.24 76.27 11.54 98.7 24.36 53.2 46.14 97.42 67.93 315.34 177.54 432 180.75l-15.38 31.4-418.53-8.33-318.54-205.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1840 107.28s33.32-15.38 54.48 0 120.52 247.4 369.79 398.66c0 0 166.32 104.79 256.05 118.89s155.11 64.09 235.86 56.4 144.21 14.1 177.54 14.1 345.46-9 345.46-9l221.76-7.05-794.75 103.86H1840.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1824.27 716.48s251.89 36.54 759.5 28.85l-56.4 21.15-338.37 8.33-369.17-5.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2799.13 736.35s-64.74-10.89-89.73-8.33-157.67 20.51-157.67 20.51-27.56 3.2-79.48 1.92c0 0-29.48 0-51.27 3.85s-139.08 13.46-165.36 12.82-424.94-5.77-424.94-5.77v21.79l387.12 25 481.34-19.87 112.8-28.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2508.14 749.17s-10.89 2.56-7 6.41 14.1 5.77 9.62 9.61-18.59 7.7-50.64 9.62-216.63 5.77-216.63 5.77l-156.39 3.84-348-1.28v14.1l444.16-7.69 150.62-4.49 130.11-5.12s46.15-3.85 51.27-9 .65-10.89-1.92-12.18-9.61-2.56-9.61-4.48 4.41-5.11 4.41-5.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M3791.28 574.84s-702.46 117.93-957.54 150c0 0-142.93 21.79-167.93 36.53s116 3.84 116 3.84-161.51 17.95-330.08 26.28-612.08 0-612.08 0v10.9l582.6 23.07 1360-4.49z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5,
    strokeMiterlimit: 10,
    stroke: "#054752",
    fill: "none",
    d: "M1873.31 560.5h1934.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1872.98 586.47h1934.64v35.04H1872.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1836.6 729.7v260.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M2059.39 706.53c-2 0-4 .1-6 .27-5.55-41.76-44.79-74.13-92.38-74.13-38.87 0-72.16 21.59-86.09 52.25a54.67 54.67 0 10-49.74 95.44A72.91 72.91 0 001919.51 882c14.8 10 33.83 16 54.6 16 40.51 0 74.42-22.85 83.12-53.49h2.16a69 69 0 000-138z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.a7268e86242522114b4dd1595c55f937.svg";
export { ForwardRef as ReactComponent };